/** 
 * Copyright (c) Open Carbon, 2020
 * 
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * action/global.js 
 * 
 * Actions for global redux object
 */ 

import { API_URL } from "../constants";
import { setURLState } from "../functions/urlstate";

/**
 * setGlobalState
 * 
 * Sets global state using a list of names/values represented by object
 * 
 * @param {*} object 
 * @param {*} history 
 * @param {*} location 
*/
export const setGlobalState = (object, history, location) => {
  return (dispatch, getState) => {
    // If setting turbinelat/lng, then modify URL to reflect this state
    if ((object.turbinelat !== undefined) && (object.turbinelng !== undefined)) {
      setURLState({ 'lat': object.turbinelat, 'lng': object.turbinelng}, history, location);
    }
    // if ((object.currentlat !== undefined) && (object.currentlng !== undefined)) {
    //   setURLState({ 'vlat': object.currentlat, 'vlng': object.currentlng}, history, location);
    // }
    
    dispatch({type: 'GLOBAL_SET_STATE', object: object});
    return Promise.resolve(true);
  }
}

/**
 * setButtonState
 * 
 * Sets global state of specific button using name/value pair
 * 
 * @param {*} buttonname
 * @param {*} buttonstate
*/
export const setButtonState = (buttonname, buttonstate) => {
  return (dispatch, getState) => {    
    dispatch({type: 'GLOBAL_SET_BUTTONSTATE', buttonname: buttonname, buttonstate: buttonstate});
    return Promise.resolve(true);
  }
}

/**
 * fetchVisibility
 * 
 * Fetches visibility GeoJSON for supplied point, turbine height and blade radius
 * 
 * @param {*} params
 */
export const fetchVisibility = (params) => {
  return (dispatch, getState) => {
    const { mapref, submapref } = getState().global;
    let headers = {"Content-Type": "application/json"};
    let body = JSON.stringify(params);
    return fetch(API_URL + "/viewshed/", {headers, method: "POST", body})
      .then(res => {
        if (res.status < 500) {
          return res.json().then(data => {
            return {status: res.status, data};
          })
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
      .then(res => {
        if (res.status === 200) {

          // Update GeoJSON layers
          if ((mapref !== null) && (mapref.current !== null)) {
            var map = mapref.current.getMap();
            map.getSource('viewshed').setData(res.data);
          }
          if ((submapref !== null) && (submapref.current !== null)) {
            var submap = submapref.current.getMap();
            submap.getSource('viewshed').setData(res.data);
          }
    
          return dispatch({type: 'FETCH_VISIBILITY', randompoint: res.data});
        }         
      })
  }
}

